<template>
  <div class="set-my-org">
    <div style="position:absolute;top:55px;right:15px" @click="setSelector = true">
      <span style="color:white;position:absolute;bottom:0;right:0;z-index:2;background:#333;border-radius:100%;height:26px;width:26px;">
        <Icon style="padding:6px" type="edit" size="15"></Icon>
      </span>
      <Avatar v-if="!profile.primary_org" style="background:#fff;border:1px dashed #aaa;border-radius:100%;width:70px;height:70px"></Avatar>
      <Avatar v-else :src="allianceInfo | getDisplayImage" style="background:#fff;border:1px dashed #aaa;border-radius:100%;width:70px;height:70px"></Avatar>
    </div>
    <Modal v-model="setSelector">
      <p slot="header" style="text-align:left">
        <span>My Organizations</span>
      </p>
      <ViewUserProfileOrganization ref="MORG" :profile="profile" :uid="profile.journal_id"></ViewUserProfileOrganization>
      <div slot="footer">

      </div>
    </Modal>
  </div>
</template>

<script>
import ViewUserProfileOrganization from '@/views/ViewUserProfileOrganization';
import Utils from '@/utils.js'

export default {
  components: {
    ViewUserProfileOrganization
  },
  data() {
    return {
      setSelector: false,
      selected: null
    }
  },
  beforeDestroy() {
    BroadcastEvent.$off('SETNEWSELECTEDORG')
  },
  created() {
    BroadcastEvent.$on('SETNEWSELECTEDORG', (id) => {
      this.setSelector = false;
      this.selected = id
      BroadcastEvent.$emit('ONFIELDCHANGE', 'primary_org')
      BroadcastEvent.$emit('ONFIELDCHANGEPRIMARYORG', id)
    })
  },
  computed: {
    selectedID: {
      get() { return this.profile.primary_org},
      set(v) {
        this.selected = v
      }
    },
    allianceInfo: {
      get () {
        if( this.selected ) {
          for( let x=0; x<this.$store.state.publicProfile.info.userOrganization.careplans.length; x++ ) {
            if( this.$store.state.publicProfile.info.userOrganization.careplans[x].careplan.id == this.selected ) {
              return this.$store.state.publicProfile.info.userOrganization.careplans[x].careplan;
              break;
            }
          }
        }
        return this.$store.state.publicProfile.info.alliance;
      }, set(v) {
        this.$store.state.publicProfile.info.alliance = v;
      }
    },
    alliances: {
      get() {
        return this.$store.state.publicProfile.myGroupType.alliance
      }
    }
  },
  filters: {
    getDisplayImage(data) {
      return Utils.getDisplayImage('group', data, 'medium')
    }
  },
  props: {
    profile: {
      type: Object
    }
  }
}


</script>

<style>

</style>
